import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../utils"

const titleVariants = cva("leading-none tracking-tight", {
  variants: {
    variant: {
      base: "font-medium",
      lg: "text-xl font-semibold",
      xl: "text-2xl font-bold",
    },
  },
  defaultVariants: {
    variant: "base",
  },
})

export interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof titleVariants> {}

const Title = React.forwardRef<HTMLHeadingElement, TitleProps>(({ className, variant, ...props }, ref) => {
  return <h2 ref={ref} className={cn(titleVariants({ variant }), className)} {...props} />
})
Title.displayName = "Title"

const Description = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("text-muted-foreground text-sm", className)} {...props} />
  )
)
Description.displayName = "Description"

export { Title, Description }
